import { render, staticRenderFns } from "./DiscrepancyTable.vue?vue&type=template&id=c162ea94"
import script from "./DiscrepancyTable.vue?vue&type=script&lang=js"
export * from "./DiscrepancyTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports